export const REDUCER_SET_BLOCKING_STATE = "SET_BLOCKING_STATE";
export const REDUCER_SET_USER_DETAILS = "SET_USER_DETAILS";
export const REDUCER_SET_COMPOUND = "SET_COMPOUND";
export const REDUCER_UPLOAD_FILE_STATUS = "UPLOAD_FILE_STATUS";
export const REDUCER_SET_COMPOUND_SELECTOR_VISIBILITY = "SET_COMPOUND_SELECTOR_VISIBILITY";